import MReport from '@mfex/mreport';
import router, {allPages} from 'common/router';
import Conf from 'site-config';
import {getBabyMode} from 'common/user-info';
import {getQueryParam} from 'common/util';
import constants from 'common/constant';
const {GOODS_TYPE} = constants;
const {BI_POSITION} = Conf;

export const mreport = new MReport();

interface TbasicUserInfo {
    uid: string;
    user_type: number;
}

interface TbasicContentInfo {
    app: string;
    app_ver: string;
}

interface TRpGoodsInfo {
    type: string;
    reasonType: string;
    goodsClassifyId: string;
    testToolsGoodsType: string;
}

interface TreportData {
    userInfo?: {[key: string]: string} & TbasicUserInfo;
    contentInfo?: {[key: string]: unknown};
    propertyInfo: {[key: string]: unknown; position: string; item_mark?: {[key: string]: unknown}};
    goodsInfoList?: Array<TRpGoodsInfo>;
}

const basicUserInfo = {} as TbasicUserInfo;
const basicContentInfo = {} as TbasicContentInfo;
const basicPropertyInfo = {
    itemid: -1,
    time: Date.now(),
    item_type: 'pt_found_maigoods' // pt虽然是指孕管，但不影响上报。如果要区分 app 渠道，可在 bi 中【用户行为数据上报】过滤器选择【app名称】来区分
};

/**
 * 上报曝光数据
 * @param {string} position Bi 点位
 */
export function addImpressionStatic(
    position: string,
    goodsInfoList?: Array<unknown> | Record<string, unknown>,
    propertyInfo?
) {
    return reportBiStatic('impression', {
        propertyInfo: {
            position,
            ...propertyInfo
        },
        goodsInfoList
    } as TreportData);
}

/**
 * 上报点击数据
 * @param {string} position Bi 点位
 */
export function addClickStatic(position) {
    return reportBiStatic('click', {
        propertyInfo: {
            position
        }
    } as TreportData);
}

/**
 * @description bi 上报方法
 * @author zhangxj
 * @date 2020-04-26
 * @export
 * @param {string} event 事件名：'impression'、'click'、'share'等
 * @param {Object} reportData ={userInfo = {}, contentInfo = {}, propertyInfo = {}, goodsInfoList={}} 上报的数据
 * @param {Object} reportData.userInfo 用户属性
 * @param {Object} reportData.contentInfo 行为上下文
 * @param {Object} reportData.propertyInfo 事件属性
 * @param {Object|Array}  reportData.goodsInfoList
 * @returns
 */
export function reportBiStatic(event, {userInfo, contentInfo, propertyInfo, goodsInfoList}: TreportData) {
    // let goodsClassify = info.goodsClassify ? parseInt(info.goodsClassify) : '';
    const routerMeta = router.currentRoute.meta;
    const context = {
        context_type: routerMeta.position,
        context_mark: {
            context_name: allPages[routerMeta.position]
        }
    };

    const user = {...basicUserInfo, ...userInfo};
    const content = {...basicContentInfo, ...context, ...contentInfo};
    const propertie = {...basicPropertyInfo, ...propertyInfo};
    const urlParams = getQueryParam();
    let properties = [];

    // 获取上报数据的来源
    propertie.item_mark = {
        ...propertyInfo.item_mark,
        item_url: location.href || '',
        fm: urlParams['fm'] || '', // 元素fm, 用于百度统计标志来源 【运营拼接】
        inside: urlParams['insidesource'] || '', //  站内的参数 【运营/后端拼接】
        outside: urlParams['outsidesource'] || '', // 无法做固定点位统计时，通过链接➕固定参数形式（仅通过运营手动加参）
        item_mark_1: routerMeta.position // 位置补充说明
    };

    const handleArray = goodsInfo => {
        const _propertie = {
            ...propertie
        };
        if (goodsInfo && goodsInfo.itemid) {
            _propertie['itemid'] = goodsInfo.itemid;
        }
        const info = goodsInfo;
        const type = info?.type ? parseInt(info.type) : '';
        const reasonType = info?.reasonType ? parseInt(info.reasonType) : '';
        const goodsClassifyId = info?.goodsClassifyId ? parseInt(info.goodsClassifyId) : '';
        const testToolsGoodsType = info?.testToolsGoodsType;

        _propertie.item_mark = {
            ..._propertie.item_mark,
            item_mark_2: type, // 上报补充说明 0 商品品类，1具体商品
            item_mark_3: reasonType, // 不喜欢的原因
            item_mark_4: goodsClassifyId, // 商品品类 id
            item_mark_5: urlParams['pid'] || '' // 淘宝 pid
        };

        if (_propertie.position === BI_POSITION.HOME_LIST && GOODS_TYPE[testToolsGoodsType]) {
            // 首页信息流
            _propertie.item_mark.item_desc = `${GOODS_TYPE[testToolsGoodsType]}`; // 选品测试的信息流商品
            _propertie.item_mark.entrance = testToolsGoodsType; // entrance元素类型标示: 作为选品测试工具的商品类型
        }
        return _propertie;
    };

    if (propertie.position === BI_POSITION.GOODS_INFO_FLOW_DIKE && routerMeta.position === 'index') {
        // 在首页信息流用户反馈弹窗 item_mark_1 被占用，也是描述位置的
        propertie.item_mark.item_mark_1 = 0; // index 首页
    }

    if (Array.isArray(goodsInfoList)) {
        properties = goodsInfoList.map(item => {
            return handleArray(item);
        });
    } else {
        properties[0] = handleArray(goodsInfoList);
    }

    return mreport.report(event, {
        user,
        content,
        properties
    });
}

// 曝光事件队列
let impressionItemList = [];
let impressionTimer = null;
/**
 * 添加曝光事件到事件队列中
 * @param {Object|Array} properties 事件属性
 */
export function addImpressionEvent(position, properties) {
    clearTimeout(impressionTimer);
    if (Array.isArray(properties)) {
        impressionItemList = [...impressionItemList, ...properties];
    } else {
        impressionItemList.push(properties);
    }
    const handleArray = item => {
        item.time = Date.now();
        return item;
    };
    const uploadData = () => {
        if (impressionItemList.length === 0) {
            return;
        }
        if (impressionItemList.length >= 10) {
            const propertiesArray = impressionItemList.splice(0, 10).map(handleArray);
            addImpressionStatic(position, propertiesArray);
            uploadData();
        } else {
            impressionTimer = setTimeout(() => {
                const propertiesArray = impressionItemList.map(handleArray);
                impressionItemList = [];
                addImpressionStatic(position, propertiesArray);
                uploadData();
            }, 3000);
        }
    };
    uploadData();
}

/**
 * 获取上报基础信息
 */
(async function setBasicInfo() {
    try {
        const {userType} = await getBabyMode(true);
        basicUserInfo.user_type = parseInt(userType) || 0;
    } catch (error) {
        basicUserInfo.user_type = 0;
    }
})();
